
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class BcbmTable extends Vue {
    //奔驰宝马
    table = {
        data: [],
        column: [
            {
                key: 'black',
                title: '下注保时捷大',
                align: 'center',
                render: (h, params) => {
                    let porsche: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.porsche) {
                        porsche = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.porsche.bet)
                    }
                    return h('div', [h('p', porsche)])
                }
            },
            {
                key: 'black',
                title: '下注保时捷小',
                align: 'center',
                render: (h, params) => {
                    let s_porsche: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.s_porsche) {
                        s_porsche = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.s_porsche.bet)
                    }
                    return h('div', [h('p', s_porsche)])
                }
            },
            {
                key: 'black',
                title: '下注奔驰大',
                align: 'center',
                render: (h, params) => {
                    let benz: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.benz) {
                        benz = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.benz.bet)
                    }
                    return h('div', [h('p', benz)])
                }
            },
            {
                key: 'black',
                title: '下注奔驰小',
                align: 'center',
                render: (h, params) => {
                    let s_benz: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.s_benz) {
                        s_benz = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.s_benz.bet)
                    }
                    return h('div', [h('p', s_benz)])
                }
            },
            {
                key: 'black',
                title: '下注宝马大',
                align: 'center',
                render: (h, params) => {
                    let bmw: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.bmw) {
                        bmw = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.bmw.bet)
                    }
                    return h('div', [h('p', bmw)])
                }
            },
            {
                key: 'black',
                title: '下注宝马小',
                align: 'center',
                render: (h, params) => {
                    let s_bmw: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.s_bmw) {
                        s_bmw = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.s_bmw.bet)
                    }
                    return h('div', [h('p', s_bmw)])
                }
            },
            {
                key: 'black',
                title: '下注大众大',
                align: 'center',
                render: (h, params) => {
                    let vm: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.vm) {
                        vm = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.vm.bet)
                    }
                    return h('div', [h('p', vm)])
                }
            },
            {
                key: 'black',
                title: '下注大众小',
                align: 'center',
                render: (h, params) => {
                    let s_vm: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.s_vm) {
                        s_vm = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.s_vm.bet)
                    }
                    return h('div', [h('p', s_vm)])
                }
            },
            {
                key: 'black',
                title: '开奖结果',
                align: 'center',
                render: (h, params) => {
                    let str = '/'
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        let s = JSON.parse(params.row.opt_detail).award_content.point.s
                        str = this.getType(s)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }
    getType(s) {
        let str = ''
        switch (s) {
            case 'porsche':
                str = '大保时捷'
                break
            case 's_porsche':
                str = '小保时捷'
                break
            case 'benz':
                str = '大奔驰'
                break
            case 's_benz':
                str = '小奔驰'
                break
            case 'bmw':
                str = '大宝马'
                break
            case 's_bmw':
                str = '小宝马'
                break
            case 'vm':
                str = '大大众'
                break
            case 's_vm':
                str = '小大众'
                break
            default:
                break
        }
        return str
    }

    @Prop()
    listdata
}
